
function obj_size(obj) {
    var size = 0, key;
    for (key in obj) {
        if (obj.hasOwnProperty(key)) size++;
    }
    return size;
};

function format_to_Money(n, c, d, t) {
  var c = isNaN(c = Math.abs(c)) ? 2 : c,
      d = d == undefined ? "." : d,
      t = t == undefined ? "," : t,
      s = n < 0 ? "-" : "",
      i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
      j = (j = i.length) > 3 ? j % 3 : 0;
  return '$ ' + s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
};
function conoce_mas(){ $('#popup').fadeIn(); $('#modal_conoce_mas').fadeIn(); }
function close_popup(){ $('#popup').fadeOut(); $('#modal_conoce_mas').fadeOut(); $('#add_tnt_kit').fadeOut(); }
function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	function webpackJsonpCallback(data) {
/******/ 		var chunkIds = data[0];
/******/ 		var moreModules = data[1];
/******/ 		var executeModules = data[2];
/******/
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(data);
/******/
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 		// add entry modules from loaded chunk to deferred list
/******/ 		deferredModules.push.apply(deferredModules, executeModules || []);
/******/
/******/ 		// run deferred modules when all chunks ready
/******/ 		return checkDeferredModules();
/******/ 	};
/******/ 	function checkDeferredModules() {
/******/ 		var result;
/******/ 		for(var i = 0; i < deferredModules.length; i++) {
/******/ 			var deferredModule = deferredModules[i];
/******/ 			var fulfilled = true;
/******/ 			for(var j = 1; j < deferredModule.length; j++) {
/******/ 				var depId = deferredModule[j];
/******/ 				if(installedChunks[depId] !== 0) fulfilled = false;
/******/ 			}
/******/ 			if(fulfilled) {
/******/ 				deferredModules.splice(i--, 1);
/******/ 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
/******/ 			}
/******/ 		}
/******/
/******/ 		return result;
/******/ 	}
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 	// Promise = chunk loading, 0 = chunk loaded
/******/ 	var installedChunks = {
/******/ 		34: 0
/******/ 	};
/******/
/******/ 	var deferredModules = [];
/******/
/******/ 	// script path function
/******/ 	function jsonpScriptSrc(chunkId) {
/******/ 		return __webpack_require__.p + "" + ({"0":"DynamicFeaturedCollection-StaticCollection-StaticProduct-StaticProductRecommendations-StaticSearch","1":"vendors-DynamicFeaturedCollection-StaticCollection-StaticProduct-StaticProductRecommendations-StaticSearch","2":"DynamicFeaturedCollection-StaticCollection-StaticProductRecommendations-StaticSearch","3":"DynamicSearch-StaticSectionHeader","4":"vendors-DynamicSearch-StaticSectionHeader","5":"Account","6":"Contact","7":"DynamicBlogPosts","8":"DynamicFeaturedCollection","9":"DynamicInstagramFeed","10":"DynamicMenuList","11":"DynamicNewsletter","12":"DynamicPromoBlocks","13":"DynamicRichText","14":"DynamicSearch","15":"DynamicTwitterFeed","16":"DynamicVideo","17":"GiftCard","18":"PXSMap","19":"Page","20":"StaticAnnouncement","21":"StaticArticle","22":"StaticBlog","23":"StaticCart","24":"StaticCollection","25":"StaticHighlightsBanners","26":"StaticPassword","27":"StaticProduct","28":"StaticProductRecommendations","29":"StaticRecentlyViewed","30":"StaticSearch","31":"StaticSectionFooter","32":"StaticSectionHeader","33":"StaticSlideshow","35":"vendors-StaticCart"}[chunkId]||chunkId) + ".bundle.js"
/******/ 	}
/******/
/******/ 	// script path function
/******/ 	function jsonpScriptSrc(chunkId) {
/******/ 	  const bundles = { '1': '//www.petmarkt.com.mx/cdn/shop/t/33/assets/vendors-DynamicFeaturedCollection-StaticCollection-StaticProduct-StaticProductRecommendations-StaticSearch.bundle.js?v=9386571128861621081708989782','0': '//www.petmarkt.com.mx/cdn/shop/t/33/assets/DynamicFeaturedCollection-StaticCollection-StaticProduct-StaticProductRecommendations-StaticSearch.bundle.js?v=17735728547650062011708989705','2': '//www.petmarkt.com.mx/cdn/shop/t/33/assets/DynamicFeaturedCollection-StaticCollection-StaticProductRecommendations-StaticSearch.bundle.js?v=135651216248684406281708989718','24': '//www.petmarkt.com.mx/cdn/shop/t/33/assets/StaticCollection.bundle.js?v=21303621028287565131684273895','28': '//www.petmarkt.com.mx/cdn/shop/t/33/assets/StaticProductRecommendations.bundle.js?v=110048186303649956101708989723','30': '//www.petmarkt.com.mx/cdn/shop/t/33/assets/StaticSearch.bundle.js?v=15831235884852842401708989723','8': '//www.petmarkt.com.mx/cdn/shop/t/33/assets/DynamicFeaturedCollection.bundle.js?v=52427786747378120881708989696','27': '//www.petmarkt.com.mx/cdn/shop/t/33/assets/StaticProduct.bundle.js?v=6285860275283798621684273895','10': '//www.petmarkt.com.mx/cdn/shop/t/33/assets/DynamicMenuList.bundle.js?v=98892211157306031861708989718','11': '//www.petmarkt.com.mx/cdn/shop/t/33/assets/DynamicNewsletter.bundle.js?v=14510547475698482141708989739','12': '//www.petmarkt.com.mx/cdn/shop/t/33/assets/DynamicPromoBlocks.bundle.js?v=85076951850775665191708989750','13': '//www.petmarkt.com.mx/cdn/shop/t/33/assets/DynamicRichText.bundle.js?v=137632692859635730521708989697','15': '//www.petmarkt.com.mx/cdn/shop/t/33/assets/DynamicTwitterFeed.bundle.js?v=64879005435802528561708989751','16': '//www.petmarkt.com.mx/cdn/shop/t/33/assets/DynamicVideo.bundle.js?v=65302084516808809711708989701','17': '//www.petmarkt.com.mx/cdn/shop/t/33/assets/GiftCard.bundle.js?v=24940414662171575521708989697','18': '//www.petmarkt.com.mx/cdn/shop/t/33/assets/PXSMap.bundle.js?v=14526719999609391481708989765','19': '//www.petmarkt.com.mx/cdn/shop/t/33/assets/Page.bundle.js?v=82400665722707951441708989723','20': '//www.petmarkt.com.mx/cdn/shop/t/33/assets/StaticAnnouncement.bundle.js?v=40042991324710152061708989727','21': '//www.petmarkt.com.mx/cdn/shop/t/33/assets/StaticArticle.bundle.js?v=103659288622114788971708989746','22': '//www.petmarkt.com.mx/cdn/shop/t/33/assets/StaticBlog.bundle.js?v=137252690747489391341708989757','25': '//www.petmarkt.com.mx/cdn/shop/t/33/assets/StaticHighlightsBanners.bundle.js?v=138124725545669640911708989780','26': '//www.petmarkt.com.mx/cdn/shop/t/33/assets/StaticPassword.bundle.js?v=3315250204983849411708989709','29': '//www.petmarkt.com.mx/cdn/shop/t/33/assets/StaticRecentlyViewed.bundle.js?v=50810759009014842471708989752','31': '//www.petmarkt.com.mx/cdn/shop/t/33/assets/StaticSectionFooter.bundle.js?v=52911676239752695561708989695','33': '//www.petmarkt.com.mx/cdn/shop/t/33/assets/StaticSlideshow.bundle.js?v=69064830539097490861648848995','35': '//www.petmarkt.com.mx/cdn/shop/t/33/assets/vendors-StaticCart.bundle.js?v=151040645128794889661651688414','23': '//www.petmarkt.com.mx/cdn/shop/t/33/assets/StaticCart.bundle.js?v=134888069728043716471726085887','4': '//www.petmarkt.com.mx/cdn/shop/t/33/assets/vendors-DynamicSearch-StaticSectionHeader.bundle.js?v=21870517550029146041619806460','3': '//www.petmarkt.com.mx/cdn/shop/t/33/assets/DynamicSearch-StaticSectionHeader.bundle.js?v=36599025490465530401694820619','14': '//www.petmarkt.com.mx/cdn/shop/t/33/assets/DynamicSearch.bundle.js?v=101847606507807184241708989714','32': '//www.petmarkt.com.mx/cdn/shop/t/33/assets/StaticSectionHeader.bundle.js?v=105055260162419670661708989769','5': '//www.petmarkt.com.mx/cdn/shop/t/33/assets/Account.bundle.js?v=149038305275426531191708989710','6': '//www.petmarkt.com.mx/cdn/shop/t/33/assets/Contact.bundle.js?v=23405493830245468301708989732','7': '//www.petmarkt.com.mx/cdn/shop/t/33/assets/DynamicBlogPosts.bundle.js?v=182443045943662495881708989757','9': '//www.petmarkt.com.mx/cdn/shop/t/33/assets/DynamicInstagramFeed.bundle.js?v=32621741005420357741708989719' };
/******/ 	  return bundles[chunkId];
/******/ 	}
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var promises = [];
/******/
/******/
/******/ 		// JSONP chunk loading for javascript
/******/
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData !== 0) { // 0 means "already installed".
/******/
/******/ 			// a Promise means "currently loading".
/******/ 			if(installedChunkData) {
/******/ 				promises.push(installedChunkData[2]);
/******/ 			} else {
/******/ 				// setup Promise in chunk cache
/******/ 				var promise = new Promise(function(resolve, reject) {
/******/ 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 				});
/******/ 				promises.push(installedChunkData[2] = promise);
/******/
/******/ 				// start chunk loading
/******/ 				var script = document.createElement('script');
/******/ 				var onScriptComplete;
/******/
/******/ 				script.charset = 'utf-8';
/******/ 				script.timeout = 120;
/******/ 				if (__webpack_require__.nc) {
/******/ 					script.setAttribute("nonce", __webpack_require__.nc);
/******/ 				}
/******/ 				script.src = jsonpScriptSrc(chunkId);
/******/
/******/ 				// create error before stack unwound to get useful stacktrace later
/******/ 				var error = new Error();
/******/ 				onScriptComplete = function (event) {
/******/ 					// avoid mem leaks in IE.
/******/ 					script.onerror = script.onload = null;
/******/ 					clearTimeout(timeout);
/******/ 					var chunk = installedChunks[chunkId];
/******/ 					if(chunk !== 0) {
/******/ 						if(chunk) {
/******/ 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
/******/ 							var realSrc = event && event.target && event.target.src;
/******/ 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
/******/ 							error.name = 'ChunkLoadError';
/******/ 							error.type = errorType;
/******/ 							error.request = realSrc;
/******/ 							chunk[1](error);
/******/ 						}
/******/ 						installedChunks[chunkId] = undefined;
/******/ 					}
/******/ 				};
/******/ 				var timeout = setTimeout(function(){
/******/ 					onScriptComplete({ type: 'timeout', target: script });
/******/ 				}, 120000);
/******/ 				script.onerror = script.onload = onScriptComplete;
/******/ 				document.head.appendChild(script);
/******/ 			}
/******/ 		}
/******/ 		return Promise.all(promises);
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
/******/ 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
/******/ 	jsonpArray.push = webpackJsonpCallback;
/******/ 	jsonpArray = jsonpArray.slice();
/******/ 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
/******/ 	var parentJsonpFunction = oldJsonpFunction;
/******/
/******/
/******/ 	// add entry module to deferred list
/******/ 	deferredModules.push([22,36]);
/******/ 	// run deferred modules when ready
/******/ 	return checkDeferredModules();
/******/ })
/************************************************************************/
/******/ ({

/***/ 22:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__(2);
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// CONCATENATED MODULE: ./source/scripts/globals/jquery.js
// jQuery plugins expect to find a global `jQuery` object, so we
// need to attach it to the window.
//
// This is in its own file because we have to attach it before any
// other imports happen, but with ES6 modules, all `import`s have
// to be at the top.

window.jQuery = jquery_default.a;
window.$ = jquery_default.a;
// EXTERNAL MODULE: ./node_modules/jquery-trend/jquery.trend.js
var jquery_trend = __webpack_require__(9);

// EXTERNAL MODULE: ./node_modules/jquery-revealer/jquery.revealer.js
var jquery_revealer = __webpack_require__(10);

// EXTERNAL MODULE: ./node_modules/flickity/js/index.js
var js = __webpack_require__(6);
var js_default = /*#__PURE__*/__webpack_require__.n(js);

// CONCATENATED MODULE: ./source/scripts/globals/flickity-ios-fix.js

 // This is required to fix an iOS10 bug for Flickity.
// It is our own implementation of the Flickity 2.0 fix found here: http://bit.ly/2kU4mKW

jquery_default()(window).on('dragStart', function (event) {
  var $target = jquery_default()(event.target);
  var $flickityEnabledEl = $target.closest('.flickity-enabled');

  if ($flickityEnabledEl.length) {
    var flickity = js_default.a.data($flickityEnabledEl[0]);
    window.removeEventListener('scroll', flickity);
  }
});
// EXTERNAL MODULE: ./node_modules/scriptjs/dist/script.js
var script = __webpack_require__(5);
var script_default = /*#__PURE__*/__webpack_require__.n(script);

// EXTERNAL MODULE: ./node_modules/rimg-shopify/dist/index.es.js + 1 modules
var index_es = __webpack_require__(7);

// CONCATENATED MODULE: ./source/scripts/Sections.js
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { if (i % 2) { var source = arguments[i] != null ? arguments[i] : {}; ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(arguments[i])); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(arguments[i], key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }


/**
 * Allows a callback to be run once, when a target intersects the viewport.
 * @constructor
 * @param {Object} [options] options with which to construct the IntersectionObserver
 * @param {string} [options.rootMargin='30%'] A string which specifies a set of offsets to add to
 *                                          the root's bounding_box when calculating intersections.
 * @param {number} [options.threshold=0] Ratio of intersection required to trigger callback
 */
var LazyLoader =
/*#__PURE__*/
function () {
  function LazyLoader(options) {
    _classCallCheck(this, LazyLoader);

    var defaultOptions = {
      rootMargin: '30%',
      threshold: 0
    };
    this.callbacks = new WeakMap();
    this._observerCallback = this._observerCallback.bind(this);
    this.observer = new IntersectionObserver(this._observerCallback, _objectSpread({}, defaultOptions, {}, options));
  }
  /**
   * Add target and callback. Callback is only run once.
   * @add
   * @param {HTMLElement} target Target element
   * @param {function} callback Callback to run when target begins intersecting
   */


  _createClass(LazyLoader, [{
    key: "add",
    value: function add(target, callback) {
      this.callbacks.set(target, callback);
      this.observer.observe(target);
    }
    /**
     * Remove target. Associated callback is also removed.
     * @remove
     * @param {HTMLElement} target Target element
     */

  }, {
    key: "remove",
    value: function remove(target) {
      this.observer.unobserve(target);
      this.callbacks.delete(target);
    }
    /**
     * Disconnects IntersectionObserver if active
     * @unload
     */

  }, {
    key: "unload",
    value: function unload() {
      this.observer.disconnect();
    }
    /**
     * Runs associated callbacks for each entry, then removes that entry and callback
     * @_observerCallback
     * @param {IntersectionObserverEntry[]} entries Entries to check
     * @param {InterserctionObserver} observer IntersectionObserver instance
     */

  }, {
    key: "_observerCallback",
    value: function _observerCallback(entries, observer) {
      var _this = this;

      entries.forEach(function (_ref) {
        var isIntersecting = _ref.isIntersecting,
            target = _ref.target;

        // do nothing unless target moved into state of intersection
        if (isIntersecting === true) {
          // make sure we stop observing before running the callback, so we don't
          // somehow run the callback twice if element intersects twice quickly
          observer.unobserve(target);

          var callback = _this.callbacks.get(target);

          if (typeof callback === 'function') {
            callback();
          }

          _this.callbacks.delete(target);
        }
      });
    }
  }]);

  return LazyLoader;
}();

var Sections =
/*#__PURE__*/
function () {
  function Sections() {
    _classCallCheck(this, Sections);

    this.handlers = {};
    this.instances = {};
    this.options = {};
    this.imports = {};
    this.lazyLoader = null;
    this._onSectionEvent = this._onSectionEvent.bind(this);
    document.addEventListener('shopify:section:load', this._onSectionEvent);
    document.addEventListener('shopify:section:unload', this._onSectionEvent);
    document.addEventListener('shopify:section:select', this._onSectionEvent);
    document.addEventListener('shopify:section:deselect', this._onSectionEvent);
    document.addEventListener('shopify:block:select', this._onSectionEvent);
    document.addEventListener('shopify:block:deselect', this._onSectionEvent);
  }
  /**
   * Stop listening for section events, and unbind all handlers.
   */


  _createClass(Sections, [{
    key: "unbind",
    value: function unbind() {
      document.removeEventListener('shopify:section:load', this._onSectionEvent);
      document.removeEventListener('shopify:section:unload', this._onSectionEvent);
      document.removeEventListener('shopify:section:select', this._onSectionEvent);
      document.removeEventListener('shopify:section:deselect', this._onSectionEvent);
      document.removeEventListener('shopify:block:select', this._onSectionEvent);
      document.removeEventListener('shopify:block:deselect', this._onSectionEvent); // Unload all instances

      for (var i = 0; i < this.instances.length; i++) {
        this._triggerInstanceEvent(this.instances[i], 'onSectionUnload');
      }

      this.handlers = {};
      this.options = {};
      this.lazyLoader.unload();
      this.lazyLoader = null;
      this.instances = {};
    }
    /**
     * Register a section handler.
     *
     * @param {string} type
     *        The section type to handle. The handler will be called for all
     *        sections with this type.
     *
     * @param {function} handler
     *        The handler function is passed information about a specific section
     *        instance. The handler is expected to return an object that will be
     *        associated with the section instance.
     *
     *        Section handlers are passed an object with the following parameters:
     *          {string} id
     *          An ID that maps to a specific section instance. Typically the
     *          section's filename for static sections, or a generated ID for
     *          dynamic sections.
     *
     *          {string} type
     *          The section type, as supplied when registered.
     *
     *          {Element} el
     *          The root DOM element for the section instance.
     *
     *          {Object} data
     *          Data loaded from the section script element. Defaults to an
     *          empty object.
     *
     *          {Function} postMessage
     *          A function that can be called to pass messages between sections.
     *          The function should be called with a message "name", and
     *          optionally some data.
     *
     * @param {object} options
     *
     * @param {boolean} options.lazy
     *     If true, sections will only be initialized after they intersect the viewport + 30% margin
     */

  }, {
    key: "register",
    value: function register(type, handler) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (this.handlers[type]) {
        console.warn("Sections: section handler already exists of type '".concat(type, "'."));
      } // Store the section handler


      this.handlers[type] = handler; // Store options

      this.options[type] = options; // Init sections for this type

      this._initSections(type);
    }
    /**
     * Initialize sections already on the page.
     */

  }, {
    key: "_initSections",
    value: function _initSections(type) {
      var _this2 = this;

      // Fetch all existing sections of our type on the page
      var dataEls = document.querySelectorAll("[data-section-type=\"".concat(type, "\"]"));
      if (!dataEls) return; // Create an instance for each section

      var _loop = function _loop(i) {
        var dataEl = dataEls[i];
        var el = dataEl.parentNode; // Get instance ID

        var idEl = el.querySelector('[data-section-id]');

        if (!idEl) {
          console.warn("Sections: unable to find section id for '".concat(type, "'."), el);
          return "continue"; // eslint-disable-line no-continue
        }

        var sectionId = idEl.getAttribute('data-section-id');

        if (!sectionId) {
          console.warn("Sections: unable to find section id for '".concat(type, "'."), el);
          return "continue"; // eslint-disable-line no-continue
        }

        if (_this2.options[type] && _this2.options[type].lazy) {
          if (_this2.lazyLoader === null) {
            _this2.lazyLoader = new LazyLoader();
          }

          _this2.lazyLoader.add(el, function () {
            return _this2._createInstance(sectionId, el);
          });
        } else {
          _this2._createInstance(sectionId, el);
        }
      };

      for (var i = 0; i < dataEls.length; i++) {
        var _ret = _loop(i);

        if (_ret === "continue") continue;
      }
    }
  }, {
    key: "_onSectionEvent",
    value: function _onSectionEvent(event) {
      var el = event.target;
      var _event$detail = event.detail,
          sectionId = _event$detail.sectionId,
          blockId = _event$detail.blockId;
      var instance = this.instances[sectionId];

      switch (event.type) {
        case 'shopify:section:load':
          this._createInstance(sectionId, el);

          break;

        case 'shopify:section:unload':
          this._triggerInstanceEvent(instance, 'onSectionUnload', {
            el: el,
            id: sectionId
          });

          if (this.lazyLoader) {
            this.lazyLoader.remove(el);
          }

          delete this.instances[sectionId];
          break;

        case 'shopify:section:select':
          this._triggerInstanceEvent(instance, 'onSectionSelect', {
            el: el,
            id: sectionId
          });

          break;

        case 'shopify:section:deselect':
          this._triggerInstanceEvent(instance, 'onSectionDeselect', {
            el: el,
            id: sectionId
          });

          break;

        case 'shopify:block:select':
          this._triggerInstanceEvent(instance, 'onSectionBlockSelect', {
            el: el,
            id: blockId
          });

          break;

        case 'shopify:block:deselect':
          this._triggerInstanceEvent(instance, 'onSectionBlockDeselect', {
            el: el,
            id: blockId
          });

          break;

        default:
          break;
      }
    }
  }, {
    key: "_triggerInstanceEvent",
    value: function _triggerInstanceEvent(instance, eventName) {
      if (instance && instance[eventName]) {
        for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
          args[_key - 2] = arguments[_key];
        }

        instance[eventName].apply(instance, args);
      }
    }
  }, {
    key: "_postMessage",
    value: function _postMessage(name, data) {
      var _this3 = this;

      Object.keys(this.instances).forEach(function (id) {
        _this3._triggerInstanceEvent(_this3.instances[id], 'onSectionMessage', name, data);
      });
    }
  }, {
    key: "_createInstance",
    value: function _createInstance(id, el) {
      var _this4 = this;

      var typeEl = el.querySelector('[data-section-type]');
      if (!typeEl) return;
      var type = typeEl.getAttribute('data-section-type');
      if (!type) return;
      var handler = this.handlers[type];

      if (!handler) {
        console.warn("Sections: unable to find section handler for type '".concat(type, "'."));
        return;
      }

      var data = this._loadData(el);

      var postMessage = this._postMessage.bind(this);

      var handlerParams = {
        id: id,
        type: type,
        el: el,
        data: data,
        postMessage: postMessage
      };

      if (!this.imports[type]) {
        handler().then(function (_ref2) {
          var Component = _ref2.default;
          _this4.imports[type] = Component;
          _this4.instances[id] = new Component(handlerParams);
        });
      } else {
        this.instances[id] = new this.imports[type](handlerParams);
      }
    }
  }, {
    key: "_loadData",
    value: function _loadData(el) {
      var dataEl = el.querySelector('[data-section-data]');
      if (!dataEl) return {}; // Load data from attribute, or innerHTML

      var data = dataEl.getAttribute('data-section-data') || dataEl.innerHTML;

      try {
        return JSON.parse(data);
      } catch (error) {
        console.warn("Sections: invalid section data found. ".concat(error.message));
        return {};
      }
    }
  }]);

  return Sections;
}();


// CONCATENATED MODULE: ./source/scripts/checkPolyfills.js
var polyfillUrls = []; // Checks if all IntersectionObserver and IntersectionObserverEntry
// features are natively supported.

if (!('IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype)) {
  polyfillUrls.push(document.querySelector('[data-scripts]').dataset.pxuPolyfills);
} // Polyfill NodeList.forEach if required.
// Polyfill is so small it doesn't need to load any external code.


if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

/* harmony default export */ var checkPolyfills = (polyfillUrls);
// CONCATENATED MODULE: ./source/scripts/Empire.js
// jQuery plugins

 // eslint-disable-line

 // eslint-disable-line
// Global imports


 // Responsive Images

 // eslint-disable-line
// Section Manager

 // Polyfills



var Empire_initEmpire = function initEmpire() {
  index_es["a" /* default */].init('[data-rimg="lazy"]', {
    round: 1
  });
  var sections = new Sections(); // Static sections

  sections.register('static-header', function () {
    return Promise.all(/* import() | StaticSectionHeader */[__webpack_require__.e(4), __webpack_require__.e(3), __webpack_require__.e(32)]).then(__webpack_require__.bind(null, 78));
  });
  sections.register('static-announcement', function () {
    return __webpack_require__.e(/* import() | StaticAnnouncement */ 20).then(__webpack_require__.bind(null, 50));
  });
  sections.register('static-footer', function () {
    return __webpack_require__.e(/* import() | StaticSectionFooter */ 31).then(__webpack_require__.bind(null, 51));
  });
  sections.register('static-article', function () {
    return __webpack_require__.e(/* import() | StaticArticle */ 21).then(__webpack_require__.bind(null, 52));
  });
  sections.register('static-blog', function () {
    return __webpack_require__.e(/* import() | StaticBlog */ 22).then(__webpack_require__.bind(null, 53));
  });
  sections.register('static-cart', function () {
    return Promise.all(/* import() | StaticCart */[__webpack_require__.e(35), __webpack_require__.e(23)]).then(__webpack_require__.bind(null, 54));
  });
  sections.register('static-collection', function () {
    return Promise.all(/* import() | StaticCollection */[__webpack_require__.e(1), __webpack_require__.e(0), __webpack_require__.e(2), __webpack_require__.e(24)]).then(__webpack_require__.bind(null, 55));
  });
  sections.register('static-password', function () {
    return __webpack_require__.e(/* import() | StaticPassword */ 26).then(__webpack_require__.bind(null, 56));
  });
  sections.register('static-product', function () {
    return Promise.all(/* import() | StaticProduct */[__webpack_require__.e(1), __webpack_require__.e(0), __webpack_require__.e(27)]).then(__webpack_require__.bind(null, 57));
  });
  sections.register('static-product-recommendations', function () {
    return Promise.all(/* import() | StaticProductRecommendations */[__webpack_require__.e(1), __webpack_require__.e(0), __webpack_require__.e(2), __webpack_require__.e(28)]).then(__webpack_require__.bind(null, 58));
  });
  sections.register('static-recently-viewed', function () {
    return __webpack_require__.e(/* import() | StaticRecentlyViewed */ 29).then(__webpack_require__.bind(null, 59));
  });
  sections.register('static-search', function () {
    return Promise.all(/* import() | StaticSearch */[__webpack_require__.e(1), __webpack_require__.e(0), __webpack_require__.e(2), __webpack_require__.e(30)]).then(__webpack_require__.bind(null, 60));
  });
  sections.register('static-highlights-banners', function () {
    return __webpack_require__.e(/* import() | StaticHighlightsBanners */ 25).then(__webpack_require__.bind(null, 61));
  });
  sections.register('static-slideshow', function () {
    return __webpack_require__.e(/* import() | StaticSlideshow */ 33).then(__webpack_require__.bind(null, 62));
  }, {
    lazy: true
  }); // Dynamic sections (lazy loaded)\

  sections.register('dynamic-blog-posts', function () {
    return __webpack_require__.e(/* import() | DynamicBlogPosts */ 7).then(__webpack_require__.bind(null, 63));
  }, {
    lazy: true
  });
  sections.register('dynamic-promo-mosaic', function () {
    return __webpack_require__.e(/* import() | DynamicPromoBlocks */ 12).then(__webpack_require__.bind(null, 64));
  }, {
    lazy: true
  });
  sections.register('dynamic-promo-grid', function () {
    return __webpack_require__.e(/* import() | DynamicPromoBlocks */ 12).then(__webpack_require__.bind(null, 64));
  }, {
    lazy: true
  });
  sections.register('dynamic-menu-list', function () {
    return __webpack_require__.e(/* import() | DynamicMenuList */ 10).then(__webpack_require__.bind(null, 65));
  }, {
    lazy: true
  });
  sections.register('dynamic-twitter-feed', function () {
    return __webpack_require__.e(/* import() | DynamicTwitterFeed */ 15).then(__webpack_require__.bind(null, 66));
  }, {
    lazy: true
  });
  sections.register('dynamic-instagram-feed', function () {
    return __webpack_require__.e(/* import() | DynamicInstagramFeed */ 9).then(__webpack_require__.bind(null, 67));
  }, {
    lazy: true
  });
  sections.register('dynamic-featured-collection', function () {
    return Promise.all(/* import() | DynamicFeaturedCollection */[__webpack_require__.e(1), __webpack_require__.e(0), __webpack_require__.e(2), __webpack_require__.e(8)]).then(__webpack_require__.bind(null, 68));
  }, {
    lazy: true
  });
  sections.register('dynamic-featured-product', function () {
    return Promise.all(/* import() | StaticProduct */[__webpack_require__.e(1), __webpack_require__.e(0), __webpack_require__.e(27)]).then(__webpack_require__.bind(null, 57));
  }, {
    lazy: true
  });
  sections.register('dynamic-rich-text', function () {
    return __webpack_require__.e(/* import() | DynamicRichText */ 13).then(__webpack_require__.bind(null, 69));
  }, {
    lazy: true
  });
  sections.register('dynamic-search', function () {
    return Promise.all(/* import() | DynamicSearch */[__webpack_require__.e(4), __webpack_require__.e(3), __webpack_require__.e(14)]).then(__webpack_require__.bind(null, 70));
  }, {
    lazy: true
  });
  sections.register('dynamic-video', function () {
    return __webpack_require__.e(/* import() | DynamicVideo */ 16).then(__webpack_require__.bind(null, 71));
  }, {
    lazy: true
  });
  sections.register('pxs-newsletter', function () {
    return __webpack_require__.e(/* import() | DynamicNewsletter */ 11).then(__webpack_require__.bind(null, 72));
  }, {
    lazy: true
  });
  sections.register('pxs-map', function () {
    return __webpack_require__.e(/* import() | PXSMap */ 18).then(__webpack_require__.bind(null, 73));
  }, {
    lazy: true
  });

  if (document.body.classList.contains('template-giftcard')) {
    __webpack_require__.e(/* import() | GiftCard */ 17).then(__webpack_require__.bind(null, 74)).then(function (_ref) {
      var GiftCard = _ref.default;
      return new GiftCard();
    });
  }

  if (document.body.classList.contains('template-account')) {
    __webpack_require__.e(/* import() | Account */ 5).then(__webpack_require__.bind(null, 75)).then(function (_ref2) {
      var Account = _ref2.default;
      return new Account();
    });
  }
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Fix Edit Address ( Error Theme )
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  if (document.body.classList.contains('template-addresses')) {
    __webpack_require__.e(/* import() | Account */ 5).then(__webpack_require__.bind(null, 75)).then(function (_ref2) {
      var Account = _ref2.default;
      return new Account();
    });
  }
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Fix Edit Address ( Error Theme )
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  if (document.body.classList.contains('template-contact')) {
    __webpack_require__.e(/* import() | Contact */ 6).then(__webpack_require__.bind(null, 76)).then(function (_ref3) {
      var Contact = _ref3.default;
      return new Contact();
    });
  }

  if (document.body.classList.contains('template-page')) {
    __webpack_require__.e(/* import() | Page */ 19).then(__webpack_require__.bind(null, 77)).then(function (_ref4) {
      var Page = _ref4.default;
      return new Page();
    });
  } // Flickity hot fix until Webkit fixes this bug: https://bugs.webkit.org/show_bug.cgi?id=184250#c31


  $(document).on('dragStart.flickity', '.flickity-enabled', function () {
    document.ontouchmove = function (e) {
      e.preventDefault();
    };
  });
  $(document).on('dragEnd.flickity', '.flickity-enabled', function () {
    document.ontouchmove = function () {
      return true;
    };
  });
};

if (checkPolyfills.length) {
  script_default()(checkPolyfills, Empire_initEmpire);
} else {
  Empire_initEmpire();
}

/***/ })

/******/ });

  
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  $(document).on('click','[data-login-toggle]',function(){
    $('[data-account-login-recovery]').toggle();
    $('[data-account-login-main]').toggle();
  });

  /////////////////////////////////////////////////////////////////////////////////////
  $(document).on('change','.form-field-input',function(){
    var actv = $(this).val();
    if(actv.length > 0){
      $(this).addClass('form-field-filled').css('border','');
    }else{
      $(this).removeClass('form-field-filled');
    }
  })
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  $(document).on('change','input[name="action_billing_address"]',function(){
    ////////////////////////////////////////////////////////////////////////////////////////////////
    if($(this).val() == 'NO'){ $('.direccion_facturacion').css('display',''); }else{ $('.direccion_facturacion').css('display','none'); }
    ////////////////////////////////////////////////////////////////////////////////////////////////
  });
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  $(document).ready(function(){
    ////////////////////////////////////////////////////////////////////////////////////////////////
    console.log("asking template");
    ////////////////////////////////////////////////////////////////////////////////////////////////
    var template = $('html').attr('template');
    console.log(template);
    ////////////////////////////////////////////////////////////////////////////////////////////////
    if (template == 'page.registro') {
      ////////////////////////////////////////////////////////////////////////////////////////////////
      console.log(window.location);
      ////////////////////////////////////////////////////////////////////////////////////////////////
      var searchParams = new URLSearchParams(window.location.search);
      ////////////////////////////////////////////////////////////////////////////////////////////////
      if (searchParams.has("email")) {
        ////////////////////////////////////////////////////////////////////////////////////////////////
        var email = searchParams.get("email");
        ////////////////////////////////////////////////////////////////////////////////////////////////
        console.log(email);
        ////////////////////////////////////////////////////////////////////////////////////////////////
        $.post('https://app.petmarkt.com.mx/fetch/ws/hubspot_client.php',{email:email},function(data){
          console.log(data);
          ////////////////////////////////////////////////////////////////////////////////////////////////
          var obj = JSON.parse(data);
          var first_name = obj.first_name;
          var last_name = obj.last_name;
          var whatsapp = obj.whatsapp;
          var company_name = obj.company_name;
          ////////////////////////////////////////////////////////////////////////////////////////////////
          if( first_name != undefined ){ $('[name="first_name"]').addClass('form-field-filled').val(first_name); }
          if( last_name != undefined ){ $('[name="last_name"]').addClass('form-field-filled').val(last_name); }
          if( whatsapp != undefined ){ $('[name="whatsapp"]').addClass('form-field-filled').val(whatsapp); }
          if( company_name != undefined ){ $('[name="company_name"]').addClass('form-field-filled').val(company_name); }
          ////////////////////////////////////////////////////////////////////////////////////////////////
        });
        ////////////////////////////////////////////////////////////////////////////////////////////////
      }
      ////////////////////////////////////////////////////////////////////////////////////////////////
    }
    ////////////////////////////////////////////////////////////////////////////////////////////////
  });
  
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  $(document).on('click','#quick_register_dvp',function(){
    ////////////////////////////////////////////////////////////////////////////////////////////////
    var new_customer = {customer:{},shipping_address:{},billing_address:{},metafields:{}};
    var error = 'FALSO';
    ////////////////////////////////////////////////////////////////////////////////////////////////
    var terminos_y_condiciones = $('input[name="terminos_y_condiciones"]:checked').val();
    ////////////////////////////////////////////////////////////////////////////////////////////////
    if(terminos_y_condiciones == 'SI'){
      ////////////////////////////////////////////////////////////////////////////////////////////////
      $('.distribuidor_form input[obj="customer"]').each(function(){
        ////////////////////////////////////////////////////////////////////////////////////////////////
        var obj = $(this).attr('obj');
        var name = $(this).attr('name');
        var val = $(this).val();
        ////////////////////////////////////////////////////////////////////////////////////////////////
        if(( name == 'email' || name == 'phone' || name == 'first_name' || name == 'last_name' ) && !(val.length > 0) ){
          ////////////////////////////////////////////////////////////////////////////////////////////////
          var tthis = $(this);
          tthis.css('border-color','red');
          tthis.parent().find('label').css('color','red');
          setTimeout(function(){ tthis.css('border-color',''); tthis.parent().find('label').css('color',''); },5000);
          error = 'ERROR';
          ////////////////////////////////////////////////////////////////////////////////////////////////
        }
        ////////////////////////////////////////////////////////////////////////////////////////////////
        if(name == 'email' && !(validateEmail(val)) ){
          var tthis = $(this);
          tthis.css('border-color','red');
          tthis.parent().find('label').css('color','red');
          setTimeout(function(){ tthis.css('border-color',''); tthis.parent().find('label').css('color',''); },5000);
          error = 'ERROR';
        }
        ////////////////////////////////////////////////////////////////////////////////////////////////
        if(name == 'password' && !(val.length > 6) ){
          var tthis = $(this);
          tthis.css('border-color','red');
          tthis.parent().find('label').css('color','red');
          setTimeout(function(){ tthis.css('border-color',''); tthis.parent().find('label').css('color',''); },5000);
          error = 'ERROR';
        }
        ////////////////////////////////////////////////////////////////////////////////////////////////
        new_customer[obj][name] = val;
        ////////////////////////////////////////////////////////////////////////////////////////////////
      });
      ////////////////////////////////////////////////////////////////////////////////////////////////
      $('.distribuidor_form input[obj="metafields"]').each(function(){
        var obj = $(this).attr('obj');
        var name = $(this).attr('name');
        var val = $(this).val();
        ////////////////////////////////////////////////////////////////////////////////////////////////
        if(( name == 'company_name' ) && !(val.length > 0) ){
          ////////////////////////////////////////////////////////////////////////////////////////////////
          var tthis = $(this);
          tthis.css('border-color','red');
          tthis.parent().find('label').css('color','red');
          setTimeout(function(){ tthis.css('border-color',''); tthis.parent().find('label').css('color',''); },5000);
          error = 'ERROR';
          ////////////////////////////////////////////////////////////////////////////////////////////////
        }
        ////////////////////////////////////////////////////////////////////////////////////////////////
        new_customer[obj][name] = val;
        ////////////////////////////////////////////////////////////////////////////////////////////////
      });
      ////////////////////////////////////////////////////////////////////////////////////////////////
      ////////////////////////////////////////////////////////////////////////////////////////////////
      var read_billing_address = $('input[name="quick_action_billing_address"]:checked').val();
      ////////////////////////////////////////////////////////////////////////////////////////////////
      if(read_billing_address == 'SI' ){
        ////////////////////////////////////////////////////////////////////////////////////////////////
        $('.distribuidor_form input[obj="metafields"]').each(function(){
          var obj = $(this).attr('obj');
          var name = $(this).attr('name');
          var val = $(this).val();
          new_customer[obj][name] = val;
          ////////////////////////////////////////////////////////////////////////////////////////////////
          ////////////////////////////////////////////////////////////////////////////////////////////////
          if(( name == 'rfc' || name == 'razon_social' ) && !(val.length >= 1) ){
            ////////////////////////////////////////////////////////////////////////////////////////////////
            var tthis = $(this);
            tthis.css('border-color','red');
            tthis.parent().find('label').css('color','red');
            setTimeout(function(){ tthis.css('border-color',''); tthis.parent().find('label').css('color',''); },5000);
            error = 'ERROR';
            ////////////////////////////////////////////////////////////////////////////////////////////////
          }
          ////////////////////////////////////////////////////////////////////////////////////////////////
          new_customer[obj][name] = val;
          ////////////////////////////////////////////////////////////////////////////////////////////////
        });
        ////////////////////////////////////////////////////////////////////////////////////////////////
        $('.distribuidor_form input[obj="billing_address"]').each(function(){
          var obj = $(this).attr('obj');
          var name = $(this).attr('name');
          var val = $(this).val();
          new_customer[obj][name] = val;
          ////////////////////////////////////////////////////////////////////////////////////////////////
          ////////////////////////////////////////////////////////////////////////////////////////////////
          if(( name == 'address1' || name == 'address2' || name == 'num_ext' || name == 'city' || name == 'zipcode' ) && !(val.length >= 1) ){
            ////////////////////////////////////////////////////////////////////////////////////////////////
            var tthis = $(this);
            tthis.css('border-color','red');
            tthis.parent().find('label').css('color','red');
            setTimeout(function(){ tthis.css('border-color',''); tthis.parent().find('label').css('color',''); },5000);
            error = 'ERROR';
            ////////////////////////////////////////////////////////////////////////////////////////////////
          }
          ////////////////////////////////////////////////////////////////////////////////////////////////
          new_customer[obj][name] = val;
          ////////////////////////////////////////////////////////////////////////////////////////////////
        });
        ////////////////////////////////////////////////////////////////////////////////////////////////
        $('.distribuidor_form select[obj="billing_address"]').each(function(){
          var obj = $(this).attr('obj');
          var name = $(this).attr('name');
          var val = $(this).val();
          if( val == null ){
            ////////////////////////////////////////////////////////////////////////////////////////////////
            var tthis = $(this);
            tthis.css('border-color','red');
            tthis.parent().find('label').css('color','red');
            setTimeout(function(){ tthis.css('border-color',''); tthis.parent().find('label').css('color',''); },5000);
            error = 'ERROR';
            ////////////////////////////////////////////////////////////////////////////////////////////////
          }
          new_customer[obj][name] = val;
        });
        ////////////////////////////////////////////////////////////////////////////////////////////////
      }
      ////////////////////////////////////////////////////////////////////////////////////////////////
      if( error != 'ERROR' ) {
        ////////////////////////////////////////////////////////////////////////////////////////////////
        $('.error_mensaje').html('<h2 style="color: #000; "><i class="fas fa-spinner fa-pulse" style="font-size: 80px;"></i></h2>');
        ////////////////////////////////////////////////////////////////////////////////////////////////
        console.log({new_customer:new_customer,read_billing_address:read_billing_address});
        ////////////////////////////////////////////////////////////////////////////////////////////////
        $.post('https://app.petmarkt.com.mx/fetch/hooks/quick_creates_new_customer.php',{new_customer:new_customer,read_billing_address:read_billing_address},function(data){
          ////////////////////////////////////////////////////////////////////////////////////////////////
          ////////////////////////////////////////////////////////////////////////////////////////////////
          if(data.includes('error')){
            ////////////////////////////////////////////////////////////////////////////////////////////////
            var obj = JSON.parse(data);
            ////////////////////////////////////////////////////////////////////////////////////////////////
            $('.error_mensaje').html(obj.code);
            ////////////////////////////////////////////////////////////////////////////////////////////////
            setTimeout(function(){ $('.error_mensaje').html(''); },5000);
            ////////////////////////////////////////////////////////////////////////////////////////////////
          }else{
            ////////////////////////////////////////////////////////////////////////////////////////////////
            $('.error_mensaje').html('<h3>'+data+'</h3>');
            ////////////////////////////////////////////////////////////////////////////////////////////////
            setTimeout(function(){
              window.location.replace("https://www.petmarkt.com.mx/account/login?account=success");
            },5000);
            ////////////////////////////////////////////////////////////////////////////////////////////////
          }
          ////////////////////////////////////////////////////////////////////////////////////////////////
          ////////////////////////////////////////////////////////////////////////////////////////////////
        });
        ////////////////////////////////////////////////////////////////////////////////////////////////
      }else{
        ////////////////////////////////////////////////////////////////////////////////////////////////
        $('.error_mensaje').html('<h3>Lo sentimos. Revisa los campos marcados en rojo ya que pueden estar en blanco o se coloco informacion erronea.</h3>');
        ////////////////////////////////////////////////////////////////////////////////////////////////
        setTimeout(function(){ $('.error_mensaje').html(''); },5000);
        ////////////////////////////////////////////////////////////////////////////////////////////////
      }
      ////////////////////////////////////////////////////////////////////////////////////////////////
    }else{
      ////////////////////////////////////////////////////////////////////////////////////////////////
      $('.error_mensaje').html('<h3>Acepta los términos y condiciones.</h3>');
      ////////////////////////////////////////////////////////////////////////////////////////////////
      var tthis = $('input[name="terminos_y_condiciones"]');
      tthis.css('border-color','red');
      tthis.parent().find('label').css('color','red');
      setTimeout(function(){ tthis.css('border-color',''); tthis.parent().find('label').css('color',''); },5000);
      ////////////////////////////////////////////////////////////////////////////////////////////////
      setTimeout(function(){ $('.error_mensaje').html(''); },5000);
      ////////////////////////////////////////////////////////////////////////////////////////////////
    }
    ////////////////////////////////////////////////////////////////////////////////////////////////

    ////////////////////////////////////////////////////////////////////////////////////////////////
  });
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  $(document).on('click','#complete_register_dvp',function(){
    ////////////////////////////////////////////////////////////////////////////////////////////////
    var new_customer = {customer:{},shipping_address:{},billing_address:{},metafields:{}};
    var error = 'FALSO';
    ////////////////////////////////////////////////////////////////////////////////////////////////
    var terminos_y_condiciones = $('input[name="terminos_y_condiciones"]:checked').val();
    ////////////////////////////////////////////////////////////////////////////////////////////////
    if(terminos_y_condiciones == 'SI'){
      ////////////////////////////////////////////////////////////////////////////////////////////////
      $('.distribuidor_form input[obj="customer"]').each(function(){
        ////////////////////////////////////////////////////////////////////////////////////////////////
        var obj = $(this).attr('obj');
        var name = $(this).attr('name');
        var val = $(this).val();
        ////////////////////////////////////////////////////////////////////////////////////////////////
        if(( name == 'email' || name == 'phone' || name == 'first_name' || name == 'last_name' ) && !(val.length > 0) ){
          ////////////////////////////////////////////////////////////////////////////////////////////////
          var tthis = $(this);
          tthis.css('border-color','red');
          tthis.parent().find('label').css('color','red');
          setTimeout(function(){ tthis.css('border-color',''); tthis.parent().find('label').css('color',''); },5000);
          error = 'ERROR';
          ////////////////////////////////////////////////////////////////////////////////////////////////
        }
        ////////////////////////////////////////////////////////////////////////////////////////////////
        if(name == 'email' && !(validateEmail(val)) ){
          var tthis = $(this);
          tthis.css('border-color','red');
          tthis.parent().find('label').css('color','red');
          setTimeout(function(){ tthis.css('border-color',''); tthis.parent().find('label').css('color',''); },5000);
          error = 'ERROR';
        }
        ////////////////////////////////////////////////////////////////////////////////////////////////
        if(name == 'password' && !(val.length > 6) ){
          var tthis = $(this);
          tthis.css('border-color','red');
          tthis.parent().find('label').css('color','red');
          setTimeout(function(){ tthis.css('border-color',''); tthis.parent().find('label').css('color',''); },5000);
          error = 'ERROR';
        }
        ////////////////////////////////////////////////////////////////////////////////////////////////
        new_customer[obj][name] = val;
        ////////////////////////////////////////////////////////////////////////////////////////////////
      });
      ////////////////////////////////////////////////////////////////////////////////////////////////
      $('.distribuidor_form input[obj="shipping_address"]').each(function(){
        var obj = $(this).attr('obj');
        var name = $(this).attr('name');
        var val = $(this).val();
        ////////////////////////////////////////////////////////////////////////////////////////////////
        if(( name == 'address1' || name == 'address2' || name == 'num_ext' || name == 'city' || name == 'zipcode' ) && !(val.length >= 1) ){
          ////////////////////////////////////////////////////////////////////////////////////////////////
          var tthis = $(this);
          tthis.css('border-color','red');
          tthis.parent().find('label').css('color','red');
          setTimeout(function(){ tthis.css('border-color',''); tthis.parent().find('label').css('color',''); },5000);
          error = 'ERROR';
          ////////////////////////////////////////////////////////////////////////////////////////////////
        }
        ////////////////////////////////////////////////////////////////////////////////////////////////
        new_customer[obj][name] = val;
        ////////////////////////////////////////////////////////////////////////////////////////////////
      });
      ////////////////////////////////////////////////////////////////////////////////////////////////
      $('.distribuidor_form input[obj="metafields"]').each(function(){
        var obj = $(this).attr('obj');
        var name = $(this).attr('name');
        var val = $(this).val();
        ////////////////////////////////////////////////////////////////////////////////////////////////
        if(( name == 'company_name' ) && !(val.length > 0) ){
          ////////////////////////////////////////////////////////////////////////////////////////////////
          var tthis = $(this);
          tthis.css('border-color','red');
          tthis.parent().find('label').css('color','red');
          setTimeout(function(){ tthis.css('border-color',''); tthis.parent().find('label').css('color',''); },5000);
          error = 'ERROR';
          ////////////////////////////////////////////////////////////////////////////////////////////////
        }
        ////////////////////////////////////////////////////////////////////////////////////////////////
        new_customer[obj][name] = val;
        ////////////////////////////////////////////////////////////////////////////////////////////////
      });
      ////////////////////////////////////////////////////////////////////////////////////////////////
      $('.distribuidor_form select[obj="metafields"]').each(function(){
        var obj = $(this).attr('obj');
        var name = $(this).attr('name');
        var val = $(this).val();
        if( val == null ){
          ////////////////////////////////////////////////////////////////////////////////////////////////
          val = '';
          ////////////////////////////////////////////////////////////////////////////////////////////////
        }
        new_customer[obj][name] = val;
      });
      ////////////////////////////////////////////////////////////////////////////////////////////////
      $('.distribuidor_form select[obj="shipping_address"]').each(function(){
        var obj = $(this).attr('obj');
        var name = $(this).attr('name');
        var val = $(this).val();
        if( val == null ){
          ////////////////////////////////////////////////////////////////////////////////////////////////
          var tthis = $(this);
          tthis.css('border-color','red');
          tthis.parent().find('label').css('color','red');
          setTimeout(function(){ tthis.css('border-color',''); tthis.parent().find('label').css('color',''); },5000);
          error = 'ERROR';
          ////////////////////////////////////////////////////////////////////////////////////////////////
        }
        new_customer[obj][name] = val;
      });
      ////////////////////////////////////////////////////////////////////////////////////////////////
      ////////////////////////////////////////////////////////////////////////////////////////////////
      var read_billing_address = $('input[name="action_billing_address"]:checked').val();
      ////////////////////////////////////////////////////////////////////////////////////////////////
      if(read_billing_address == 'NO' ){
        ////////////////////////////////////////////////////////////////////////////////////////////////
        $('.distribuidor_form input[obj="billing_address"]').each(function(){
          var obj = $(this).attr('obj');
          var name = $(this).attr('name');
          var val = $(this).val();
          new_customer[obj][name] = val;
          ////////////////////////////////////////////////////////////////////////////////////////////////
          ////////////////////////////////////////////////////////////////////////////////////////////////
          if(( name == 'address1' || name == 'address2' || name == 'num_ext' || name == 'city' || name == 'zipcode' ) && !(val.length >= 1) ){
            ////////////////////////////////////////////////////////////////////////////////////////////////
            var tthis = $(this);
            tthis.css('border-color','red');
            tthis.parent().find('label').css('color','red');
            setTimeout(function(){ tthis.css('border-color',''); tthis.parent().find('label').css('color',''); },5000);
            error = 'ERROR';
            ////////////////////////////////////////////////////////////////////////////////////////////////
          }
          ////////////////////////////////////////////////////////////////////////////////////////////////
          new_customer[obj][name] = val;
          ////////////////////////////////////////////////////////////////////////////////////////////////
        });
        ////////////////////////////////////////////////////////////////////////////////////////////////
        $('.distribuidor_form select[obj="billing_address"]').each(function(){
          var obj = $(this).attr('obj');
          var name = $(this).attr('name');
          var val = $(this).val();
          if( val == null ){
            ////////////////////////////////////////////////////////////////////////////////////////////////
            var tthis = $(this);
            tthis.css('border-color','red');
            tthis.parent().find('label').css('color','red');
            setTimeout(function(){ tthis.css('border-color',''); tthis.parent().find('label').css('color',''); },5000);
            error = 'ERROR';
            ////////////////////////////////////////////////////////////////////////////////////////////////
          }
          new_customer[obj][name] = val;
        });
        ////////////////////////////////////////////////////////////////////////////////////////////////
      }
      ////////////////////////////////////////////////////////////////////////////////////////////////
      if( error != 'ERROR' ) {
        ////////////////////////////////////////////////////////////////////////////////////////////////
        $('.error_mensaje').html('<h2><i class="fas fa-spinner fa-pulse" style="font-size: 80px;"></i></h2>');
        ////////////////////////////////////////////////////////////////////////////////////////////////
        $.ajax({
          url:`https://app.petmarkt.com.mx/api/customers/createNewCustomer`,
          type: 'POST',
          dataType: 'json',
          headers: {
            'Content-Type': 'application/json'
          },
          data: JSON.stringify({new_customer, read_billing_address}),
          success: function(data){
            if(data.status === 'success') {
              $('.error_mensaje').html('<h3>'+data.data+'</h3>');
              setTimeout(function(){
                window.location.replace("https://www.petmarkt.com.mx/account/login?account=success");
            },5000);
            } else {
              $('.error_mensaje').html(data.message);
            }
          }
        });
        ////////////////////////////////////////////////////////////////////////////////////////////////
      }else{
        ////////////////////////////////////////////////////////////////////////////////////////////////
        $('.error_mensaje').html('<h3>Lo sentimos. Revisa los campos marcados en rojo ya que pueden estar en blanco o se coloco informacion erronea.</h3>');
        ////////////////////////////////////////////////////////////////////////////////////////////////
        setTimeout(function(){ $('.error_mensaje').html(''); },5000);
        ////////////////////////////////////////////////////////////////////////////////////////////////
      }
      ////////////////////////////////////////////////////////////////////////////////////////////////
    }else{
      ////////////////////////////////////////////////////////////////////////////////////////////////
      $('.error_mensaje').html('<h3>Acepta los términos y condiciones.</h3>');
      ////////////////////////////////////////////////////////////////////////////////////////////////
      var tthis = $('input[name="terminos_y_condiciones"]');
      tthis.css('border-color','red');
      tthis.parent().find('label').css('color','red');
      setTimeout(function(){ tthis.css('border-color',''); tthis.parent().find('label').css('color',''); },5000);
      ////////////////////////////////////////////////////////////////////////////////////////////////
      setTimeout(function(){ $('.error_mensaje').html(''); },5000);
      ////////////////////////////////////////////////////////////////////////////////////////////////
    }
    ////////////////////////////////////////////////////////////////////////////////////////////////
  });
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  setTimeout(function(){
    ////////////////////////////////////////////////////////////////////////////////////////////////
    var customer_id = $('#check_company_img').attr('customer_id');
    ////////////////////////////////////////////////////////////////////////////////////////////////
    $.post('https://app.petmarkt.com.mx/fetch/ws/image_loader.php',{customer_id:customer_id},function(data){
      $('#check_company_img').html(data);
      setTimeout(function(){ $('#upload_company_logo').attr('customer_id',customer_id); },1000);
    });
    ////////////////////////////////////////////////////////////////////////////////////////////////
  },2000);
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  $(document).on('click',"#btn_upload_company_logo",function() {
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    if ($('#upload_company_logo').val().length > 0 ) {
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      var input_img = $('#upload_company_logo');
      var customer_id = $('#upload_company_logo').attr('customer_id');
      var fd = new FormData();
      fd.append('file', input_img[0].files[0]);
      fd.append('customer_id', customer_id);
      $.ajax({url: "https://app.petmarkt.com.mx/fetch/ws/upload_customer_logo.php",
              type: "post", dataType: 'text',cache: false,
              contentType: false, processData: false, data: fd, type: 'post', success: function(data){
                console.log(data);
                ////////////////////////////////////////////////////////////////////////////////////////////////
                $.post('https://app.petmarkt.com.mx/fetch/ws/image_loader.php',{customer_id:customer_id},function(data){
                  $('#check_company_img').html(data);
                  setTimeout(function(){ $('#upload_company_logo').attr('customer_id',customer_id); },1000);
                });
                ////////////////////////////////////////////////////////////////////////////////////////////////
              }});
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      $('#upload_company_logo').val('');
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    }
  });
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  $(document).on('click',"#btn_remove_company_logo",function() {
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    var customer_id = $('#check_company_img').attr('customer_id');
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    $.post('https://app.petmarkt.com.mx/fetch/ws/remove_company_logo.php',{customer_id:customer_id},function(data){
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      console.log(data);
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      $.post('https://app.petmarkt.com.mx/fetch/ws/image_loader.php',{customer_id:customer_id},function(data){
        $('#check_company_img').html(data);
        setTimeout(function(){ $('#upload_company_logo').attr('customer_id',customer_id); },1000);
      });
    });
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  });
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  $(document).on('change',"#upload_company_logo",function() {
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    var v = $(this).val();
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    if (v.length > 0) {
      var logo_cargado = "//www.petmarkt.com.mx/cdn/shop/t/33/assets/logo_cargado.png?v=27156885030696493781619806418";
      console.log("url("+logo_cargado+")");
      $('#upload_company_logo_div').css('background-image',"url("+logo_cargado+")");
      $('#btn_upload_company_logo').css('display','');
    }else{
      $('#upload_company_logo_div').css('background-image','');
      $('#btn_upload_company_logo').css('display','none');
    }
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  });
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  $(document).on('click',".shipping_type_services_label",function() {
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    var pv = $(this).attr('pvalue');
    $('input[name="attributes[shipping_type_services]"][value="'+pv+'"]').prop('checked', true);
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    console.log('shipping_type_services_label');
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    $.get('/cart.json',function(cart){
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      var obj = cart;
      var note = obj.note;
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      if( note == null ){ note = '{}'; }
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      var note_obj = JSON.parse(note);
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      note_obj['shipping_type_services'] = pv;
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      var cart_note = JSON.stringify(note_obj);
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      $.ajax({
        url: '/cart/update.js',
        type: 'POST',
        dataType: 'json',
        data: 'note=' + attributeToString(cart_note),
      });
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      var href = $('a[name="checkout"]').attr('href');
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      $('.cart-checkout').attr('href',href);
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      if (pv == 'Dropshipping') { $('.dropshipping_meaning').css('display',''); }else{ $('.dropshipping_meaning').css('display','none'); }
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    });
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  });
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  $(document).on('change',"#dropshipping_email",function() {
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    var email = $(this).val();
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    if (email.length > 1) {
      if (validateEmail(email)) {
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        $('#dropshipping_email_err').html('').css('display','none');
        $('#dropshipping_email').css('border','');
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        $.get('/cart.json',function(cart){
          //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          var obj = cart;
          var note = obj.note;
          //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          var note_obj = JSON.parse(note);
          //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          note_obj['client_email'] = email;
          //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          console.log(note_obj);
          //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          var cart_note = JSON.stringify(note_obj);
          //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          $.ajax({
            url: '/cart/update.js',
            type: 'POST',
            dataType: 'json',
            data: 'note=' + attributeToString(cart_note),
          });
          //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        });
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      }else{
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        $('#dropshipping_email_err').html('Revisa el correo que escribiste.').css('display','');
        $('#dropshipping_email').css('border','2px solid red');
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        $.get('/cart.json',function(cart){
          //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          var obj = cart;
          var note = obj.note;
          //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          var note_obj = JSON.parse(note);
          //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          note_obj['client_email'] = null;
          //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          console.log(note_obj);
          //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          var cart_note = JSON.stringify(note_obj);
          //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          $.ajax({
            url: '/cart/update.js',
            type: 'POST',
            dataType: 'json',
            data: 'note=' + attributeToString(cart_note),
          });
          //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        });
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      }
    }else{
      $('#dropshipping_email_err').html('').css('display','none');
      $('#dropshipping_email').css('border','');
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      $.get('/cart.json',function(cart){
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        var obj = cart;
        var note = obj.note;
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        var note_obj = JSON.parse(note);
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        note_obj['client_email'] = null;
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        console.log(note_obj);
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        var cart_note = JSON.stringify(note_obj);
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        $.ajax({
          url: '/cart/update.js',
          type: 'POST',
          dataType: 'json',
          data: 'note=' + attributeToString(cart_note),
        });
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      });
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    }
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  });
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  $(document).on('change','#mark_all',function(){
    window.__cdata.account_state.selected_all = !window.__cdata.account_state.selected_all;
    const printableList = $('.printable_vendor-list');
    printableList.html('');
    Object.keys(window.__cdata.account_state.vendors).forEach((item) => {
      const checked = window.__cdata.account_state.selected_all;
      const element = $(`<div class="full_width txt_left"><input type="checkbox" class="vendors_input" value="${item}" ${checked ? 'checked' : ''}>&nbsp;<label>${item}</label></div>`);
      window.window.__cdata.account_state.vendors[item] = checked;
      printableList.append(element);
    });
  });
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  $(document).on('click','#download_catalogo_ask_btn',function(){
    $('.download_catalogo_ask').css('display','none');
    $('.download_catalogo_div').css('display','');
  });
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  $(document).on('change', '.printable_species input', function(e) {
    if (window.__cdata.account_state == null) {
      window.__cdata.account_state = { specie: [], selected_all: true, vendors: {} };
    }
    
    clearTimeout(window.__cdata.account_state.vendorTimeout);

    const value = e.target.value;
    if (window.__cdata.account_state.specie.includes(value)) {
      const index = window.__cdata.account_state.specie.indexOf(value);
      window.__cdata.account_state.specie.splice(index, 1);
    } else {
      window.__cdata.account_state.specie.push(value);
    }

    if (window.__cdata.account_state.specie.length === 0) {
      $('.printable_vendor').css('display', 'none');
      return;
    }

    window.__cdata.account_state.vendorTimeout = setTimeout(() => {
      axios.post(`${window.__cenv.API_HOST}/api/variants/searchVendorsBySpecie`, {
        store: 'petmarkt',
        specie: window.__cdata.account_state.specie,
      }, {
        headers: { 'crossorigin': true },
      })
        .then((response) => {
          const { status, data, message } = response.data;
          if (status === 'error') throw Error(message);
          const printableList = $('.printable_vendor-list');
          printableList.html('');
          if (data.length === 0) {
            html = `<label>No hay marcas disponibles</label>`;
          } else {
            data.sort((a, b) => a < b ? 1 : 0);
            data.forEach((item) => {
              if (account_allowed_vendors != null && account_allowed_vendors.includes(item)) {
                const checked = window.__cdata.account_state.selected_all || window.window.__cdata.account_state.vendors[item];
                const element = $(`<div class="full_width txt_left"><input type="checkbox" class="vendors_input" value="${item}" ${checked ? 'checked' : ''}>&nbsp;<label>${item}</label></div>`);
                window.window.__cdata.account_state.vendors[item] = checked;
                printableList.append(element);
              }
            });
          }
          $('.printable_vendor').css('display', 'block');
        })
        .catch(err => console.error(err))
    }, 600);
  });
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  $(document).on('change', '.printable_vendor-list input', function(e) {
    const { value } = e.target;
    const checked = window.__cdata.account_state.vendors[value] = !window.__cdata.account_state.vendors[value];
    const target = $(`.printable_vendor-list input[value="${value}"]`);
    if (!checked) {
      $('#mark_all')[0].checked = false;
      target[0].checked = false;
      window.__cdata.account_state.selected_all = false;
    } else {
      target[0].checked = true;
    }
  });
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  $(document).on('click','#download_catalogo_btn',function(){
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    var vendors = [];
    var customer_id = $(this).attr('customer_id');

    Object.keys(window.__cdata.account_state.vendors).forEach((item) => {
      if (window.__cdata.account_state.vendors[item]) vendors.push(item);
    });

    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    var view = $('input.viewport:checked').val();
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    var show_price = $('select.show_price').val();
    var precio_sugerido_aumentado = $('#precio_sugerido_aumentado').val();
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    $.post('https://app.petmarkt.com.mx/fetch/ws/read_lista_precios_v2.php', {
      customer_id: customer_id,
      margen_extra: precio_sugerido_aumentado,
      vendors: vendors,
      species: window.__cdata.account_state.specie,
      view: view,
      show_price: show_price
    },function(data){
      var new_url = `https://app.petmarkt.com.mx/fetch/pdfs/lista_precios_v2.php?k=${data}`;
      window.open(new_url, '_blank');
    });
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  });
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  $(document).on('click','#download_catalogo_cancell',function(){
    $('.download_catalogo_ask').css('display','');
    $('.download_catalogo_div').css('display','none');
  });
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  $(document).on('change','#filtro_tags_select',function(){
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    var actv = $(this).val();
    var href = $('#filtro_tags_select option[value="'+actv+'"]').attr('link');
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    window.location.href = href;
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  });
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  function loadCustomerLevel() {
    var path = window.location.pathname;
    var customer_id = __st.cid;
    var $container = $('#cutomer-level-container');
    var $container_suspended = $('#cutomer-suspended');
    fetch(`https://app.petmarkt.com.mx/vendors/ws/check_customer_level.php?customer_id=${customer_id}`)
      .then(response => response.json())
      .then(levels => {
        if (levels.error) throw Error(`CUSTOMER LEVEL ERROR: ${levels.message}`);
        if (!Array.isArray(levels) || levels.length === 0) return;
        levels.forEach((level) => {

          if (path === '/account' && customer_id !== null && $container !== null) {
            var { title, message } = level;
  
            var unicodeToChar = (text) => {
              return text.replace(/u[\dA-F]{4}/gi, (match) => (
                String.fromCharCode(parseInt(match.replace(/u/g, ''), 16))
              ));
            }
  
            var format = (amount) => {
              var _am = parseInt(amount);
              if (_am >= 10000) {
                return `$${(_am / 1000).toFixed(1)}K`;
              } else {
                return format_to_Money(_am, 0).replace(' ', '');
              }
            }
  
            var makeIcon = (size = 60, percent = 0, config) => {
              const fillColor = config && config.fillColor || '#FEDB41';
              const progressColor = config && config.progressColor || '#F4B844';
              const width = height = `${(size * 2) + 10}px`;
              const strokeDasharray = size * 2 * Math.PI;
              const strokeDashoffset = (strokeDasharray - (strokeDasharray * percent) / 100);
              return `<svg style="width: ${width};height: ${height}">
                <circle cx="${size}" cy="${size}" r="${size}" style="fill: ${fillColor}"></circle>
                <circle cx="${size}" cy="${size}" r="${size}"></circle>
                <circle cx="${size}" cy="${size}" r="${size}" style="stroke-dasharray: ${strokeDasharray};stroke-dashoffset: ${strokeDashoffset};stroke: ${progressColor}"></circle>
              </svg>`;
            };
  
            var element = $(`
              <div class="customer-level floating-cart">
                <div class="customer-level__icon">
                  ${makeIcon(35, level.percent, { fillColor: level.color, progressColor: level.progress_color })}
                  <div class="icon__text">
                    <span style="color: ${level.font_color}">${format(level.accumulated || 0)}<span>
                  </div>
                </div>
                <div class="customer-level__description">
                  <h2 id="level_title" class="description__title">${unicodeToChar(title)}</h2>
                  <p id="level_message" class="description__message">${unicodeToChar(message)}</h2>
                </div>
                <a class="customer-level__info" href="#cbe3e2d633">¿Cómo funciona? ></a>
              </div>
            `);

            $container.append(element);
          }

          if (level.level_name) {
            var navbarItem = `Nivel ${level.level_name}`;
            $('.site-header-account-link #customer-level').html(navbarItem);
          }

          if (level.estatus == 'V'){
            var name = level.customer_name.toLowerCase().replace(/\b[a-z]/g, function(letter) {
              return letter.toUpperCase();
            });
            var element = $(`
              <div class="customer-level floating-cart">
                <div class="customer-level__icon_alert">
                  <svg id="Layer_1" height="60px" width="60px" preserveaspectratio="none" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 122.88 111.54"><defs><style>.cls-1{fill:#fec901;}.cls-2{fill:#fec901;fill-rule:evenodd;}.cls-3{fill:#010101;}</style></defs><title>warning</title><path class="cls-1" d="M2.35,84.42,45.28,10.2l.17-.27h0A23,23,0,0,1,52.5,2.69,17,17,0,0,1,61.57,0a16.7,16.7,0,0,1,9.11,2.69,22.79,22.79,0,0,1,7,7.26q.19.32.36.63l42.23,73.34.24.44h0a22.48,22.48,0,0,1,2.37,10.19,17.63,17.63,0,0,1-2.17,8.35,15.94,15.94,0,0,1-6.93,6.6c-.19.1-.39.18-.58.26a21.19,21.19,0,0,1-9.11,1.75v0H17.61c-.22,0-.44,0-.65,0a18.07,18.07,0,0,1-6.2-1.15A16.42,16.42,0,0,1,3,104.24a17.53,17.53,0,0,1-3-9.57,23,23,0,0,1,1.57-8.74,7.66,7.66,0,0,1,.77-1.51Z"/><path class="cls-2" d="M9,88.75,52.12,14.16c5.24-8.25,13.54-8.46,18.87,0l42.43,73.69c3.39,6.81,1.71,16-9.33,15.77H17.61C10.35,103.8,5.67,97.43,9,88.75Z"/><path class="cls-3" d="M57.57,83.78A5.53,5.53,0,0,1,61,82.2a5.6,5.6,0,0,1,2.4.36,5.7,5.7,0,0,1,2,1.3,5.56,5.56,0,0,1,1.54,5,6.23,6.23,0,0,1-.42,1.35,5.57,5.57,0,0,1-5.22,3.26,5.72,5.72,0,0,1-2.27-.53A5.51,5.51,0,0,1,56.28,90a5.18,5.18,0,0,1-.36-1.27,5.83,5.83,0,0,1-.06-1.31h0a6.53,6.53,0,0,1,.57-2,4.7,4.7,0,0,1,1.14-1.56Zm8.15-10.24c-.19,4.79-8.31,4.8-8.49,0-.82-8.21-2.92-29.34-2.86-37.05.07-2.38,2-3.79,4.56-4.33a12.83,12.83,0,0,1,5,0c2.61.56,4.65,2,4.65,4.44v.24L65.72,73.54Z"/></svg>
                </div>
                <div class="customer-level__description">
                  <h4 id="level_title" class="description__title">${name}, tu cuenta presenta un saldo vencido, comunícate con nosotros para revisarlo.</h4>
                  <p id="level_message" class="description__message" style="color: #9E9E9E;">Podemos equivocarnos y si es el caso comunicate con nosotros para arreglarlo de inmediato.</p>
                </div>
              </div>
            `);

            $container_suspended.append(element);
          }
        });
      })
      .catch(console.error);
  }

  $(document).ready(() => {
    // Load level
    loadCustomerLevel();

    $(document).on('click', '#request_account_deletion', async function request_account_deletion() {
      const $el = $(this);
      const customerId = $el.data('customer_id');
      const customerEmail = $el.data('customer_email').trim();
      window.__lib.confirmationModal.btnAccept.on('click', function account_deletion() {
        window.__lib.confirmationModal.btnCancel.attr('disabled', 'disabled');
        window.__lib.confirmationModal.btnAccept.attr('disabled', 'disabled');
        window.__lib.confirmationModal.btnAccept.html('<div class="spinner"></div>');
        
        $.ajax({
          url: `${window.__cenv.API_HOST}/api/customers/request_deletion`,
          method: 'POST',
          data: `customerId=${customerId}&customerEmail=${customerEmail}`,
          success: function accountDeletionSuccess() {
            $el.attr('disabled', 'disabled');
            $el.html('Tu cuenta esta en proceso de eliminación');
            window.__lib.confirmationModal.btnCancel.removeAttr('disabled');
            window.__lib.confirmationModal.btnAccept.removeAttr('disabled');
            window.__lib.confirmationModal.btnAccept.html('Aceptar');
            window.__lib.confirmationModal.close();
            window.__lib.showToast('Solicitud de eliminación de cuenta registrada exitosamente', 1e4, 'success');
          },
          error: function accountDeletionError() {
            window.__lib.confirmationModal.btnCancel.removeAttr('disabled');
            window.__lib.confirmationModal.btnAccept.removeAttr('disabled');
            window.__lib.confirmationModal.btnAccept.html('Aceptar');
            window.__lib.confirmationModal.close();
            window.__lib.showToast('Algo salió mal, inténtalo mas tarde', 1e4, 'error');
          }
        });
      });

      window.__lib.confirmationModal.open();
    });
  });